import { gql } from '@apollo/client'

export const GET_FANTASY_LEAGUE_MEMBERS = gql`
  query GetFantasyLeagueMembers($id: ID!) {
    fantasyLeague(id: $id) {
      id
      name
      members {
        id
        role
        budget
        teamName
        user {
          id
          fullName
          picture
          updatedAt
        }
        fantasyTeamPlayers {
          id
          createdAt
          startingPosition
          releaseClause
          signedAt
          individuallyProtected
          weeklyWindowProtected
          releaseClausePayable
          player {
            id
          }
        }
      }
    }
  }
`
